import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { UrlService } from '@services/url/url.service';
import { AuthDispatch } from '@state/auth/auth.dispatch';
import { TestHooks } from './auth-container.hooks';

@Component({
	selector: 'app-auth-container',
	templateUrl: './auth-container.component.html',
	styleUrls: ['./auth-container.component.scss'],
	standalone: false,
})
export class AuthContainerComponent {
	public legalUrl = UrlService.Legal();
	public contactUrl = UrlService.Contact();
	public year = new Date().getFullYear();
	public testHooks = TestHooks;

	@Input() label: string;
	@Input() description: string;
	@Input() formGroup: FormGroup;
	@Input() disabled: boolean;
	@Input() loading: boolean;
	@Input() submitButtonText: string;
	@Input() hideSubmitButton = false;
	@Input() hideSocials = false;
	@Output() onFormSubmit = new EventEmitter<void>();

	constructor(private authDispatch: AuthDispatch) {}

	connectToGoogle(): void {
		this.authDispatch.LoginWithGoogle();
	}

	connectToMicrosoft(): void {
		this.authDispatch.LoginWithMicrosoft();
	}

	onSubmit(): void {
		this.formGroup.markAllAsTouched();
		this.onFormSubmit.emit();
	}
}
